import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconStandingGlobe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStandingGlobe"><Path d="M9.5 21.5H15.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M12.5 21.5V19" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="13" cy="9.5" r="7" stroke="currentColor"/><Path d="M6.07494 3C4.47815 4.69966 3.5 6.98729 3.5 9.50339C3.5 14.7501 7.75329 19.0034 13 19.0034C15.7722 19.0034 18.2671 17.8159 20.0038 15.9219" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStandingGlobe;
